import { Tooltip } from "primereact/tooltip";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import WalkingPersonGreen from "../assets/icons/person-walking-green.svg";
import WalkingPersonRed from "../assets/icons/person-walking-red.svg";

// export function Stepper(props) {
//   const { steps, isLate, lastStep } = props;
//   return (
//     <div>
//       <ol className="cd-breadcrumb triangle">
//         {steps.map((step, index) => {
//           const { id, time, isSlaTimeLate } = step;
//           const lastValue =
//             steps.length - 1 === index ? steps[steps.length - 1] : {};
//           if (id === lastStep) {
//             return (
//               <li key={index} className={`current-event-${index}`} data-pr-tooltip={`Current position`}>
//                 <Tooltip target={`.current-event-${index}`} />
//                 <a href="#0" className="flex justify-content-center">
//                   <img
//                     className="person"
//                     src={isSlaTimeLate ? WalkingPersonRed : WalkingPersonGreen}
//                     alt=""
//                     style={{
//                       width: 20,
//                       height: 20,
//                       marginLeft: 10,
//                       marginRight: 15,
//                     }}
//                   />
//                 </a>
//               </li>
//             );
//           } else if (id < lastStep) {
//             return (
//               // eslint-disable-next-line react/jsx-key
//               <li key={index}>
//                 <a
//                   href="#0"
//                   className="flex justify-content-center"
//                   style={
//                     time
//                       ? {
//                           backgroundColor:
//                             isSlaTimeLate || isLate ? "#ee8686" : "#9bf08d",
//                           borderColor:
//                             isSlaTimeLate || isLate ? "#ee8686" : "#9bf08d",
//                         }
//                       : { backgroundColor: "#f2b171", borderColor: "#f2b171" }
//                   }
//                 >
//                   <Tooltip target={`.time-event-${index}`} />
//                   <Tooltip target={`.manual-event-${index}`} />
//                   {time ? (
//                     <span
//                       className={`manual-event-${index}`}
//                       data-pr-tooltip={`Patient reached at ${time}`}
//                     >
//                       {time}
//                     </span>
//                   ) : (
//                     <i
//                       data-pr-tooltip={
//                         "Event is missing. Please trigger the event manually"
//                       }
//                       className={`pi pi-exclamation-triangle warning-icon manual-event-${index}`}
//                       style={{ fontSize: "1.5rem", color: "#ffff" }}
//                     />
//                   )}
//                 </a>
//               </li>
//             );
//           } else {
//             return (
//               <li key={index}>
//                 <a href="#0" className="flex justify-content-center">
//                   {time}
//                 </a>
//               </li>
//             );
//           }
//         })}
//       </ol>
//     </div>
//   );
// }
const formatData = (data) =>
  Object.keys(data).reduce((previous, d) => {
    let s = "";
    if (Array.isArray(data[d])) {
      s = data[d][0];
    } else {
      s = data[d];
    }
    return {
      ...previous,
      [d]: s,
    };
  }, {});

export function Stepper(props) {
  const navigate = useNavigate();
  const {
    steps,
    lastStep,
    dynamicWidth,
    mainIndex,
    alphabets,
    legendValue,
    patientData,
    addClass,
  } = props;

  let alignItems = "";
  let mxAuto = "";
  if (legendValue) {
    alignItems = "align-items-center";
    mxAuto = "mx-auto";
  }

  const getHeader = (mainIndex, step, justifyContent, headerLabel) => (
    <>
      {mainIndex === 0 ? (
        <div
          className={`no-animation text-lg font-bold steps-label flex ${justifyContent}`}
          data-pr-tooltip={step.label}
          style={!legendValue ? { width: "3rem", paddingBottom: "15px" } : {}}
        >
          {headerLabel}
        </div>
      ) : null}
    </>
  );
  const { t } = useTranslation();
  const COMPLETED_ON = t("COMPLETED_ON");
  const AT = t("AT");

  return (
    <ol
      className={`flex text-xs font-medium sm:text-base align-items-start ${
        mainIndex === 0
          ? addClass
            ? "animation-journey-first"
            : ""
          : addClass
          ? "animation-journey"
          : ""
      }`}
      style={{ width: "100%", margin: 0, padding: 0 }}
    >
      <Tooltip target=".steps-label" />
      {steps.map((step, index) => {
        const { id, time, isSlaTimeLate, date, actionFlowId } = step;
        const nextIsSlaTimeLate = steps[index + 1]?.isSlaTimeLate;
        const lastValue =
          steps.length - 1 === index ? steps[steps.length - 1] : {};
        let afterClasses = "";
        let style = {};
        let justifyContent = "";
        if (lastValue.time === undefined) {
          afterClasses = `relative progress-line stepper-div ${
            mainIndex === 0 ? "stepper-div-top" : ""
          }`;
          style = { width: "100%" };
        } else {
          justifyContent = "justify-content-end";
        }

        if (index !== 0 && index !== steps.length - 1) {
          justifyContent = "justify-content-center";
        }
        const headerLabel = legendValue ? alphabets[index] : step.label;
        if (id === lastStep) {
          return (
            <li key={index} className={`flex ${afterClasses}`} style={style}>
              <div
                className={`block white-space-nowrap z-5 !flex flex-column ${alignItems}`}
              >
                {getHeader(mainIndex, step, justifyContent, headerLabel)}
                <span
                  className={`flex justify-content-center align-items-center mb-1 text-sm text-white ${mxAuto}`}
                  style={{
                    width: "3rem",
                    height: "3rem",
                    background: "#edeff0",
                    border: "2px",
                    borderRadius: "9999px",
                    borderColor: "transparent",
                  }}
                >
                  {" "}
                  <Tooltip target={`.current-event-${index}`} />
                  <a href="#0" className="flex justify-content-center">
                    <img
                      className="person"
                      src={
                        isSlaTimeLate ? WalkingPersonRed : WalkingPersonGreen
                      }
                      alt=""
                      style={{
                        width: 20,
                        height: 20,
                        marginLeft: 10,
                        marginRight: 15,
                      }}
                    />
                  </a>
                </span>{" "}
              </div>
            </li>
          );
        } else if (id < lastStep) {
          return (
            <li
              key={index}
              className={`flex ${afterClasses} ${
                nextIsSlaTimeLate ? "stepper-div-D20000" : "stepper-div-27A857"
              }`}
              style={style}
            >
              <div
                className={`block white-space-nowrap z-5 !flex flex-column ${alignItems}`}
              >
                {getHeader(mainIndex, step, justifyContent, headerLabel)}
                <span
                  onClick={() =>
                    !time &&
                    navigate("/events/add", {
                      state: {
                        patientData: {
                          ...formatData(patientData),
                          action_id: actionFlowId,
                        },
                      },
                    })
                  }
                  style={{
                    width: "3rem",
                    height: "3rem",
                    background: `${
                      time ? (isSlaTimeLate ? "#D20000" : "#27A857") : "#f2b171"
                    }`,
                    border: "2px",
                    borderRadius: "9999px",
                    borderColor: "transparent",
                  }}
                  className={`flex justify-content-center align-items-center ${mxAuto} mb-1 text-sm text-white ${
                    !time ? "cursor-pointer" : ""
                  }`}
                >
                  {" "}
                  <Tooltip target={`.time-event-${index}`} />
                  <Tooltip target={`.manual-event-${index}`} />
                  {time ? (
                    <i
                      className={`manual-event-${index} pi pi-check`}
                      data-pr-tooltip={
                        `${headerLabel} ` +
                        COMPLETED_ON +
                        ` ${date} ` +
                        AT +
                        ` ${time}`
                      }
                    />
                  ) : (
                    <i
                      data-pr-tooltip={t("EVENT_MISSING")}
                      className={`pi pi-exclamation-triangle warning-icon manual-event-${index}`}
                      style={{ fontSize: "1.5rem", color: "#ffff" }}
                    />
                  )}
                </span>{" "}
                <span
                  style={{
                    color: isSlaTimeLate ? "#D20000" : "#27A857",
                  }}
                >
                  {time}
                </span>
              </div>
            </li>
          );
        } else {
          return (
            <li key={index} className={`flex ${afterClasses}`} style={style}>
              <div
                className={`block white-space-nowrap z-5 !flex flex-column ${alignItems}`}
              >
                {getHeader(mainIndex, step, justifyContent, headerLabel)}
                <span
                  className={`flex justify-content-center align-items-center ${mxAuto} mb-1 text-sm text-white`}
                  style={{
                    width: "3rem",
                    height: "3rem",
                    background: "#edeff0",
                    border: "2px",
                    borderRadius: "9999px",
                    borderColor: "transparent",
                  }}
                >
                  {" "}
                </span>{" "}
                {time}
              </div>
            </li>
          );
        }
      })}
    </ol>
  );
}
